import { MutableRefObject, useEffect } from "react";

import { FIAS_OPEN_MODAL, FIAS_CLOSE_MODAL, FIAS_SAVE_MODAL_WRONG_ID } from "../../metricsAction";
import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";

type ModalType = "fns" | "mvd" | "custom";

export const useTrackFiasModalEnter = (type: ModalType) => {
    const track = useMetrics();

    useEffect(() => {
        track(FIAS_OPEN_MODAL, { type: type });
        return () => track(FIAS_CLOSE_MODAL, { type: type });
    }, []);
};

export const useTrackWrongId = (error: MutableRefObject<boolean>, warning: MutableRefObject<boolean>) => {
    const track = useMetrics();

    useEffect(
        () => () => {
            if (error.current || warning.current) {
                track(FIAS_SAVE_MODAL_WRONG_ID, { isError: error.current });
            }
        },
        []
    );
};
